// extracted by mini-css-extract-plugin
export default {"Student":"Student_Student__Z6t8A","Picture":"Student_Picture__X-B-7","Main":"Student_Main__pgRZU","Details":"Student_Details__L2mRm","Detail":"Student_Detail__fAqJc"};